import { render, staticRenderFns } from "./SysAdminMain.vue?vue&type=template&id=3a285c1e&"
import script from "./SysAdminMain.vue?vue&type=script&lang=js&"
export * from "./SysAdminMain.vue?vue&type=script&lang=js&"
import style0 from "./SysAdminMain.vue?vue&type=style&index=0&id=3a285c1e&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a285c1e')) {
      api.createRecord('3a285c1e', component.options)
    } else {
      api.reload('3a285c1e', component.options)
    }
    module.hot.accept("./SysAdminMain.vue?vue&type=template&id=3a285c1e&", function () {
      api.rerender('3a285c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sysadmin/SysAdminMain.vue"
export default component.exports